import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { CustomerSurveyAnswer } from '@coin/shared/customer-survey/util';
import { CustomerSurveyComponent } from '../customer-survey/customer-survey.component';
import { CustomerSurveyQuestionComponent } from '../customer-survey-question/customer-survey-question.component';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { V2RadioButtonComponent } from '@coin/shared/core/ui-storybook';

@Component({
  selector: 'coin-customer-survey-answer',
  templateUrl: './customer-survey-answer.component.html',
  styleUrls: ['./customer-survey-answer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [V2RadioButtonComponent, FormsModule, TranslatePipe]
})
export class CustomerSurveyAnswerComponent {
  protected surveyComponent = inject(CustomerSurveyComponent);
  protected surveyQuestionComponent = inject(CustomerSurveyQuestionComponent);

  answer = input.required<CustomerSurveyAnswer>();
}
